import React from "react";

import { CardImg } from "../utils";
import { Image1, Image8, Image9 } from "../assets";

function Featured() {
  return (
    <div className="mt-4 py-4">
      <h1 className="font-semibold font-josefin text-6xl text-mix-400 text-center pt-20 pb-20 px-4">
        Featured Events
      </h1>

      <div className="flex flex-col lg:flex-row justify-between lg:justify-evenly items-center space-y-12 lg:space-y-0">
        <CardImg
          title="Project Avanti"
          body="'Avanti' means forward and perfectly defines our motto to keep going on and helping the next generation, i.e. the children. Under the campaign name of Avanti, we organise..."
          src={Image9}
          link="project-avanti"
        />
        <CardImg
          title="Project Ecotopia"
          body="Life is not a waste, but the living surrounded by waste are no less wasteful. Ecotopia aims to trap the non-bidegradable in forms that can be used..."
          src={Image1}
          link="project-ecotopia"
        />
        <CardImg
          title="Project Shakti"
          body="Knowing about yourself and about your body is something we lack in this time and era. Project Shakti aims to fill this gap by providing the never before taught subjects of..."
          src={Image8}
          link="project-shakti"
        />
      </div>
    </div>
  );
}

export default Featured;
